import { GetUserToken, useAuth } from 'components/AuthProvider';
import { DeleteAdminBoxesMutationVariables } from 'generated/graphql';
import { GraphQLError } from 'graphql-request/dist/types';
import { getClientSdk } from 'graphql/client';
import { useSnackbar } from 'notistack';
import { MutationFunction, useMutation } from 'react-query';
import invalidateBoxQueries from './invalidateBoxQueries';

const deleteAdminBoxes = (
  getUserToken: GetUserToken
): MutationFunction<string, DeleteAdminBoxesMutationVariables> => async (
  vars
) => {
  const token = await getUserToken();
  const data = await getClientSdk(token).DeleteAdminBoxes(vars);
  return data.delete_box?.returning[0]?.imei ?? '';
};

const useDeleteAdminBoxes = (onSuccess: () => void) => {
  const { getUserToken } = useAuth();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation<string, GraphQLError, DeleteAdminBoxesMutationVariables>(
    deleteAdminBoxes(getUserToken),
    {
      onSuccess: async (imei) => {
        onSuccess();
        enqueueSnackbar(`ボックス ${imei}が削除できました`, {
          variant: 'success',
        });
        await invalidateBoxQueries();
      },
      onError: () => {
        enqueueSnackbar(`ボックス 削除　エラー`, { variant: 'error' });
      },
    }
  );
};

export default useDeleteAdminBoxes;
